import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { shows } from '@/mocks/shows';

const heroShows = shows.filter((s) => s.isHot && s.isNew).slice(0, 3);

export default function HeroBanner() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroShows.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const currentShow = heroShows[currentIndex];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={currentShow.coverImage}
        alt={currentShow.title}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-2 mb-4">
              <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                热播中
              </span>
              <span className="px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                {currentShow.episodes}期全
              </span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 leading-tight">
              {currentShow.title}
            </h1>
            <p className="text-background-200 text-sm md:text-base mb-6 max-w-xl line-clamp-2">
              {currentShow.description}
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to={`/article/${currentShow.id}`}
                className="px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即观看
              </Link>
              <span className="text-background-300 text-sm">
                <strong className="text-primary-400">{currentShow.rating}</strong> 分 | {currentShow.views}次播放
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroShows.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              index === currentIndex
                ? 'w-6 bg-primary-500'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}